import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "profile-page",
  class: "row"
}
const _hoisted_2 = { class: "col-lg-6 col-md-12" }
const _hoisted_3 = { class: "card mb-4" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "switch" }
const _hoisted_8 = ["checked"]
const _hoisted_9 = {
  key: 0,
  class: "card mb-4"
}
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "card mb-4" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "col-lg-6 col-md-12" }
const _hoisted_15 = { class: "card mb-4" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "card mb-4" }
const _hoisted_18 = {
  key: 0,
  class: "card-header scenario-field-header"
}
const _hoisted_19 = {
  key: 1,
  class: "card-header scenario-field-header"
}
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "card mb-4" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-md-8" }
const _hoisted_26 = { class: "switch" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = { class: "col-md-8" }
const _hoisted_29 = { class: "switch" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = { class: "col-md-8" }
const _hoisted_32 = { class: "switch" }
const _hoisted_33 = ["checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_image = _resolveComponent("profile-image")!
  const _component_edit_profile_field = _resolveComponent("edit-profile-field")!
  const _component_edit_availability = _resolveComponent("edit-availability")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Personal Information", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_profile_image, { user: _ctx.user }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "first_name",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "last_name",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "email",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "password",
            type: "password"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "dob",
            type: "date",
            "override-label": "DOB"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "mobile_number",
            type: "mobile",
            require_mobile: _ctx.require_mobile
          }, null, 8, ["user", "require_mobile"]),
          _createElementVNode("div", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-md-4" }, [
              _createElementVNode("span", { class: "slider-text text-muted d-inline-block" }, "SMS Notifications: ")
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", _hoisted_7, [
                _createElementVNode("input", {
                  id: "sms_checkbox",
                  type: "checkbox",
                  checked: _ctx.user.props.enable_sms_notifications,
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSms && _ctx.toggleSms(...args)))
                }, null, 40, _hoisted_8),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "slider round" }, null, -1))
              ])
            ])
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row" }, [
            _createElementVNode("div", { class: "col-md-12 text-muted sms-text" }, [
              _createTextVNode("You will receive visit confirmation messages and reminders via SMS when signing up for SP-ed. Message and data rates may apply. Message Frequency Varies. Reply HELP for help. Reply STOP to opt out. "),
              _createElementVNode("a", {
                href: "/#/privacy-policy",
                target: "_blank"
              }, "Privacy Policy"),
              _createTextVNode(" | "),
              _createElementVNode("a", {
                href: "/#/terms-of-service",
                target: "_blank"
              }, "SMS Terms of Service")
            ])
          ], -1))
        ])
      ]),
      (_ctx.store.getters.hasPermission('user.availability'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Availability", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "sunday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "monday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "tuesday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "wednesday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "thursday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "friday"
              }, null, 8, ["user"]),
              _createVNode(_component_edit_availability, {
                user: _ctx.user,
                field: "saturday"
              }, null, 8, ["user"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Additional Information", -1)),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "job_title",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "company_name",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "profession_id",
            type: "profession",
            "override-label": "Profession"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "specialty_id",
            type: "specialty",
            "override-label": "Specialty"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "medical_degree",
            type: "text"
          }, null, 8, ["user"]),
          ((_ctx.store.getters.registation_fields.length > 0))
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters.registation_fields, (field) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: field.id
                  }, [
                    (field.field_name != 'profession' && field.field_name != 'specialty' && field.field_name != 'job_title')
                      ? (_openBlock(), _createBlock(_component_edit_profile_field, {
                          key: 0,
                          user: _ctx.user,
                          field: field.field_name,
                          type: field.field_type,
                          "registration-field-id": field.id
                        }, null, 8, ["user", "field", "type", "registration-field-id"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Address", -1)),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "text",
            field: "address_1"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "text",
            field: "address_2"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "text",
            field: "city"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "state",
            field: "state_id",
            "override-label": "State"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "country",
            field: "country_id",
            "override-label": "Country"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            type: "timezone",
            field: "timezone_id",
            "override-label": "Time Zone"
          }, null, 8, ["user"])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        ((!_ctx.store.getters.hasRole(_ctx.UserRole.LEARNER)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Licenses & Experience"))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, "Licenses")),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "license_number",
            type: "text"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "state_licensed",
            type: "state"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "dea_number",
            type: "text",
            "override-label": "DEA Number"
          }, null, 8, ["user"]),
          _createVNode(_component_edit_profile_field, {
            user: _ctx.user,
            field: "npi_number",
            type: "text",
            "override-label": "NPI Number"
          }, null, 8, ["user"]),
          ((!_ctx.store.getters.hasRole(_ctx.UserRole.LEARNER)))
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "my-3" }, [
                  _createElementVNode("strong", null, "Experience")
                ], -1)),
                _createVNode(_component_edit_profile_field, {
                  user: _ctx.user,
                  field: "years_of_experience",
                  type: "number"
                }, null, 8, ["user"]),
                _createVNode(_component_edit_profile_field, {
                  user: _ctx.user,
                  field: "experience",
                  type: "editor"
                }, null, 8, ["user"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header scenario-field-header" }, "Notifications", -1)),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-md-4" }, [
              _createElementVNode("span", { class: "slider-text d-inline-block" }, "Email Notifications")
            ], -1)),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.user.props.enable_email_notifications,
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleEmail && _ctx.toggleEmail(...args)))
                }, null, 40, _hoisted_27),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "slider round" }, null, -1))
              ])
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-md-4" }, [
              _createElementVNode("span", { class: "slider-text d-inline-block" }, "Push Notifications")
            ], -1)),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("label", _hoisted_29, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.user.props.enable_push_notifications,
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.togglePush && _ctx.togglePush(...args)))
                }, null, 40, _hoisted_30),
                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "slider round" }, null, -1))
              ])
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "col-md-4" }, [
              _createElementVNode("span", { class: "slider-text d-inline-block" }, "Auto Login")
            ], -1)),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                _createElementVNode("input", {
                  type: "checkbox",
                  checked: _ctx.user.props.auto_login,
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleAutoLogin && _ctx.toggleAutoLogin(...args)))
                }, null, 40, _hoisted_33),
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "slider round" }, null, -1))
              ])
            ])
          ])
        ]),
        _createVNode(_component_Loading, {
          active: _ctx.loading,
          "is-full-page": false
        }, null, 8, ["active"])
      ])
    ])
  ]))
}